import { FC, useContext, useEffect, useId, useSyncExternalStore } from 'react';
import Button from '../../atoms/Button';
import Modal from '../../atoms/Modal';
import { UnsavedEditContext } from '../../context/UnsavedEditContext';
import { ACCOUNT_SWITCH_SCREEN_Z_INDEX } from '../../lib/zIndex';
import { accountSwitchStore, watchUnsavedInput } from './accountSwitch';
import './AccountSwitchScreen.scss';

/**
 * Экран «Учётная запись сменилась»: закрывает страницу прежней учётной записи, пока она не перезагрузилась, — её
 * действия ушли бы с токеном новой. Подключается в оболочке приложения один раз, внутри корневой
 * `UnsavedEditScope`: оттуда же экран узнаёт о несохранённой правке при переключении в соседней вкладке.
 */
const AccountSwitchScreen: FC = () => {
    const area = useContext(UnsavedEditContext);
    const state = useSyncExternalStore(accountSwitchStore.subscribe, accountSwitchStore.getSnapshot, () => null);
    const messageId = useId();

    useEffect(() => (area ? watchUnsavedInput(() => area.blocksLeave()) : undefined), [area]);

    if (!state) return null;
    return (
        <Modal
            opened
            size="s"
            header="Учётная запись сменилась"
            aria-describedby={messageId}
            className="rf-account-switch-screen"
            zIndex={ACCOUNT_SWITCH_SCREEN_Z_INDEX}
            footer={
                <Button size="lg" data-autofocus data-testid="account-switch-reload" onClick={state.retry}>
                    Обновить страницу
                </Button>
            }
        >
            <p id={messageId} className="rf-account-switch-screen__message" data-testid="account-switch-screen">
                В этом браузере выполнен вход в другую учётную запись. Обновите страницу: действия на ней сейчас
                выполнялись бы от имени новой учётной записи, а несохранённые изменения не сохранятся.
            </p>
        </Modal>
    );
};

export default AccountSwitchScreen;
